"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MembershipQuestionAnswers = exports.ValidationError = exports.MAX_ANSWER_LENGTH = exports.MIN_ANSWER_LENGTH = void 0;
exports.MIN_ANSWER_LENGTH = 1;
exports.MAX_ANSWER_LENGTH = 250;
var ValidationError;
(function (ValidationError) {
    ValidationError["REQUIRED"] = "REQUIRED";
    ValidationError["MAX_LENGTH"] = "MAX_LENGTH";
})(ValidationError = exports.ValidationError || (exports.ValidationError = {}));
var MembershipQuestionAnswers = /** @class */ (function () {
    function MembershipQuestionAnswers() {
    }
    MembershipQuestionAnswers.fromQuestions = function (questions) {
        var _qa = questions.reduce(function (qa, question) {
            qa[question.questionId] = { question: question };
            return qa;
        }, {});
        var mqa = new MembershipQuestionAnswers();
        mqa.qa = _qa;
        return mqa;
    };
    MembershipQuestionAnswers.prototype.getQuestionIdAnswers = function () {
        return this.getAllAnswers()
            .filter(function (a) { return a.textAnswer; })
            .map(function (a) {
            return { questionId: a.question.questionId, textAnswer: a.textAnswer };
        });
    };
    MembershipQuestionAnswers.prototype.getAllAnswers = function () {
        return Object.values(this.qa);
    };
    MembershipQuestionAnswers.prototype.getAnswer = function (questionId) {
        return this.qa[questionId];
    };
    MembershipQuestionAnswers.prototype.answer = function (questionId, textAnswer) {
        var qa = this.qa[questionId];
        qa.textAnswer = textAnswer;
        return qa;
    };
    MembershipQuestionAnswers.prototype.validate = function (questionId) {
        var qa = this.getAnswer(questionId);
        var length = qa.textAnswer === undefined ? 0 : qa.textAnswer.length;
        if (length > exports.MAX_ANSWER_LENGTH) {
            return ValidationError.MAX_LENGTH;
        }
        if (qa.question.required && length < exports.MIN_ANSWER_LENGTH) {
            return ValidationError.REQUIRED;
        }
        return null;
    };
    MembershipQuestionAnswers.prototype.isValid = function (questionId) {
        return this.validate(questionId) === null;
    };
    return MembershipQuestionAnswers;
}());
exports.MembershipQuestionAnswers = MembershipQuestionAnswers;
//# sourceMappingURL=MembershipQuestionAnswers.js.map